import React from "react";
import { Formik, Form, Field } from "formik";
import ModalComponent from "../../../components/Modal";
import TextInput from "../../../components/TextInput";
import TextArea from "../../../components/TextArea";
import { clientValidationSchema } from "../../../components/Helpers";

const AddClientModal = ({
  onClose,
  show,
  title,
  initialValues,
  onAddClient,
}) => {
  const handleCloseModals = () => {
    onClose();
  };

  return (
    <ModalComponent show={show} onClose={onClose} title={title}>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={clientValidationSchema}
        onSubmit={(values, { resetForm }) => {
          if (onAddClient) onAddClient(values);
          resetForm();
          onClose();
        }}
      >
        {({ errors, touched, handleChange, setFieldValue, values, isSubmitting }) => (
          <Form className="max-h-[85vh] overflow-y-auto">
            <div className="mt-4" />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <TextInput
                  value={values?.clientName}
                  name="clientName"
                  placeholder="Client Name"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Client Name"
                />
                {errors.clientName && touched.clientName && (
                  <div className="text-red-500 text-sm">{errors.clientName}</div>
                )}
              </div>
              <div>
                <TextInput
                  value={values?.clientLocation}
                  name="clientLocation"
                  placeholder="Client Location"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Client Location"
                />
                {errors.clientLocation && touched.clientLocation && (
                  <div className="text-red-500 text-sm">{errors.clientLocation}</div>
                )}
              </div>
              <div>
                <TextInput
                  value={values?.vendor}
                  name="vendor"
                  placeholder="Vendor"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Vendor"
                />
                {errors.vendor && touched.vendor && (
                  <div className="text-red-500 text-sm">{errors.vendor}</div>
                )}
              </div>
              <div>
                <TextInput
                  value={values?.jobTitle}
                  name="jobTitle"
                  placeholder="Job Title"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Job Title"
                />
                {errors.jobTitle && touched.jobTitle && (
                  <div className="text-red-500 text-sm">{errors.jobTitle}</div>
                )}
              </div>
              <div>
                <TextInput
                  value={values?.rate}
                  name="rate"
                  placeholder="Rate"
                  handleChange={handleChange}
                  type="text"
                  classes="w-full"
                  legend="Rate"
                />
                {errors.rate && touched.rate && (
                  <div className="text-red-500 text-sm">{errors.rate}</div>
                )}
              </div>
             
              <div className="flex items-center space-x-4">
                  <label className="text-slate-400 text-base font-medium">
                    Status:
                  </label>
                  <label className="flex items-center space-x-2 text-lg">
                    <Field
                      type="radio"
                      name="status"
                      value="A"
                      checked={values.status === "A"}
                    />
                    <span>Active</span>
                  </label>
                  <label className="flex items-center space-x-2 text-lg">
                    <Field
                      type="radio"
                      name="status"
                      value="D"
                      checked={values.status === "D"}
                    />
                    <span>Deactive</span>
                  </label>
                </div>
              
              <div className="sm:col-span-2 flex flex-col items-start">
                <label className="block text-slate-400 text-sm mb-2">Notes</label>
                <TextArea
                  value={values.notes}
                  name="notes"
                  placeholder="Notes"
                  handleChange={handleChange}
                  rows={3}
                  className="border rounded-lg w-full p-2"
                  classes="w-full"
                  style={{ minWidth: "100%", maxWidth: "100%" }}
                />
                {errors.notes && touched.notes && (
                  <div className="text-red-500 text-sm">{errors.notes}</div>
                )}
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row justify-end gap-2 mt-6">
              <button
                type="button"
                className="bg-gray-300 text-black h-10 py-1 px-4 w-full sm:w-40 rounded-lg hover:bg-gray-400"
                onClick={handleCloseModals}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="bg-[#201F1E] text-white h-10 py-1 px-4 w-full sm:w-40 rounded-lg hover:bg-[#201F1E]"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </ModalComponent>
  );
};

export default AddClientModal;